import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useLoadPermissions } from "@/stores/permissionAtom";

export default function AuthPermissionListener() {
    const { status } = useSession();
    const loadPermissions = useLoadPermissions();
    const hasFetched = useRef(false);

    useEffect(() => {
        // Only fetch if authenticated and haven't fetched yet in this session lifecycle
        if (status === "authenticated" && !hasFetched.current) {
            loadPermissions();
            hasFetched.current = true;
        }
    }, [status, loadPermissions]);

    return null; 
}